// BAG CRAP — Navigation Option B (Oct 2026): laptop Shop dropdown + phone menu tabs.
(function () {
  // Laptop/tablet "Shop" dropdown. Mouse users get it on hover (CSS); this handles taps and the keyboard.
  var shop = document.querySelector("header.bcn .bcn-shop");
  if (shop) {
    var btn = shop.querySelector(".bcn-shop-btn");
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    var setOpen = function (open) {
      shop.classList.toggle("open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    };
    btn.addEventListener("click", function (event) {
      // Touch screens: first tap opens the dropdown instead of leaving the page.
      if (!canHover.matches) {
        event.preventDefault();
        setOpen(!shop.classList.contains("open"));
      }
    });
    shop.addEventListener("mouseenter", function () { if (canHover.matches) btn.setAttribute("aria-expanded", "true"); });
    shop.addEventListener("mouseleave", function () { if (canHover.matches) setOpen(false); });
    // Keyboard only: opening on focus would fight the tap toggle above.
    var usingPointer = false;
    document.addEventListener("pointerdown", function () { usingPointer = true; }, true);
    document.addEventListener("keydown", function () { usingPointer = false; }, true);
    shop.addEventListener("focusin", function () { if (!usingPointer) setOpen(true); });
    shop.addEventListener("focusout", function (event) {
      if (!shop.contains(event.relatedTarget)) setOpen(false);
    });
    document.addEventListener("click", function (event) {
      if (shop.classList.contains("open") && !shop.contains(event.target)) setOpen(false);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && shop.classList.contains("open")) {
        setOpen(false);
        btn.focus();
      }
    });
    // Coming back with the Back button: start closed.
    window.addEventListener("pageshow", function () { setOpen(false); });
  }

  // Menu photos sit in hidden panels, so the browser would only fetch them when a menu opens
  // (a blank flash). Fetch them quietly once the page itself has finished loading.
  var warmMenuImages = function () {
    setTimeout(function () {
      document.querySelectorAll(".bcn-tile img, .bcn-m-tile img").forEach(function (img) { img.loading = "eager"; });
    }, 1500);
  };
  if (document.readyState === "complete") warmMenuImages();
  else window.addEventListener("load", warmMenuImages);

  // Collection pages: the current page's chip now sits up front next to New / Sale
  // (snippets/collection-filters-split.liquid, Oct 18, 2026), so the row starts at the beginning.

  // Collection pages: ‹ › arrows on the chip row for mouse users.
  document.querySelectorAll(".bcn-chips-wrap").forEach(function (wrap) {
    var chips = wrap.querySelector(".bcn-chips");
    var update = function () {
      var max = chips.scrollWidth - chips.clientWidth;
      wrap.classList.toggle("can-left", chips.scrollLeft > 2);
      wrap.classList.toggle("can-right", chips.scrollLeft < max - 2);
    };
    var step = function (dir) { chips.scrollBy({ left: dir * Math.round(chips.clientWidth * 0.7), behavior: "smooth" }); };
    wrap.querySelector(".bcn-chips-prev").addEventListener("click", function () { step(-1); });
    wrap.querySelector(".bcn-chips-next").addEventListener("click", function () { step(1); });
    chips.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  // Phone menu tabs: Characters / Type / More
  var tabs = document.querySelectorAll(".bcn-m .bcn-m-tabs [role=tab]");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute("aria-selected", on ? "true" : "false");
        var panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) panel.hidden = !on;
      });
    });
  });
})();
